import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectInvites, selectMembers } from '@/store/features/member/memberSlice'
import { sortInvites, sortMembers } from '@/utils/sorting'

export const useSortedMembers = () => {
  const members = useSelector(selectMembers)
  const invites = useSelector(selectInvites)

  const sortedMembers = useMemo(() => sortMembers(members), [members])
  const sortedInvites = useMemo(() => sortInvites(invites), [invites])

  return {
    members: sortedMembers,
    invites: sortedInvites,
  }
}
